<div
  #chatBox
  #dragRef="cdkDrag"
  coinResizable
  class="chat-dialog"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  animate.enter="fade-in"
  animate.leave="fade-out"
  [drag]="dragRef"
  [cdkDragConstrainPosition]="constrainPosition"
  [tabIndex]="-1">
  <coin-celebration-animation
    [hasMessages]="hasMessages()"
    [isFaqScreenActive]="isFaqScreenActive()" />

  <coin-chat-dialog-header
    cdkDragHandle
    [title]="'chat-bot.window.title' | translate"
    [showFaqButton]="isActiveFeature"
    [isFaqActive]="isFaqScreenActive()"
    [theme]="celebrationType()"
    (closePress)="closeChat()"
    (faqPress)="toggleFaq()"></coin-chat-dialog-header>

  @if (!isActiveFeature) {
    <!-- Feature disabled for this stage: show notice instead of CopilotKit -->
    <div class="chat-feature-disabled">
      <span>{{ 'chat-bot.window.feature-disabled' | translate }}</span>
    </div>
  } @else {
    @if (isFaqScreenActive()) {
      <coin-chat-faq-screen (backPress)="toggleFaq()" />
    }

    <!-- Chat content: kept in DOM while FAQ is shown to preserve CopilotKit state -->
    <div
      class="chat-content-wrapper"
      [hidden]="isFaqScreenActive()">
      <!-- Messages area: welcome overlay + CopilotKit messages -->
      <div class="chat-messages-area">
        @if (hasNoMessages()) {
          <coin-chat-start-view
            class="chat-welcome-overlay"
            [name]="chatStore.user()?.firstName ?? ''"
            [prompts]="promptGenerator.prompts()"
            (promptSelected)="submitMessage($event)" />
        }
        @if (chatStore.everAuthenticated()) {
          <copilot-chat
            #copilotChat
            class="coco-chat"
            [inputComponent]="nullInputType"
            [threadId]="chatStore.threadId()"></copilot-chat>
        }
      </div>

      <!-- Error indicator: agent stopped without producing a response -->
      @if (hasAgentError()) {
        <div class="agent-error-indicator">
          <div class="agent-error-indicator__avatar"></div>
          <div class="agent-error-indicator__content">
            <span class="agent-error-indicator__text">{{ 'chat-bot.error.agent-failed' | translate }}</span>
            <button
              class="agent-error-indicator__retry"
              (click)="retryLastMessage()">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>
      }

      <!-- Thinking indicator: agent running but no content yet -->
      @if (isThinking()) {
        <div class="thinking-indicator">
          <div class="thinking-indicator__avatar"></div>
          <div class="thinking-indicator__dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      }

      <!-- Custom input footer (replaces CopilotKit's default input) -->
      <coin-chat-dialog-footer
        [isSendDisabled]="isAgentBusy()"
        [isRestartDisabled]="hasNoMessages()"
        (sendMessage)="submitMessage($event)"
        (restartChat)="clearConversation()" />
    </div>
  }

  <!-- Resize handles -->
  <div
    class="resize-handle bottom-right"
    data-direction="bottom-right">
    <mat-icon>filter_list</mat-icon>
  </div>

  <!-- Holi background - Festival of Colors theme -->
  @if (showHoliBackground() && !isFaqScreenActive()) {
    <div class="holi-background"></div>
  }
</div>
